module.exports = __webpack_public_path__ + "img/img_11.412d30fe.png";